import {
  Text,
  GreenGreen20,
  GreenGreen50,
  GreenGreen70,
  OrangeOrange10,
  OrangeOrange40,
  OrangeOrange70,
  Primary12SemiBold,
  Box
} from '@sequencehq/core-components'

type ProductGraphPercentBadgeProps = {
  value: number
}

const getStyle = (
  value: number,
  {
    positive,
    negative,
    neutral
  }: { positive: string; negative: string; neutral: string }
) => {
  if (value > 0) {
    return positive
  } else if (value < 0) {
    return negative
  } else {
    return neutral
  }
}

export const ProductGraphPercentBadge = ({
  value
}: ProductGraphPercentBadgeProps) => {
  const sign = getStyle(value, { positive: '+', negative: '', neutral: '' })

  const boxBorderColor = getStyle(value, {
    positive: GreenGreen50,
    negative: OrangeOrange40,
    neutral: ''
  })

  const boxBackgroundColor = getStyle(value, {
    positive: GreenGreen20,
    negative: OrangeOrange10,
    neutral: ''
  })

  const textColor = getStyle(value, {
    positive: GreenGreen70,
    negative: OrangeOrange70,
    neutral: ''
  })

  return (
    <Box
      padding="2px 8px"
      borderWidth="1px"
      borderColor={boxBorderColor}
      background={boxBackgroundColor}
      borderRadius="99px"
    >
      <Text color={textColor} {...Primary12SemiBold}>
        {sign}
        {value}%
      </Text>
    </Box>
  )
}
